import {Report} from '@/modules/neodash/model/types/interfaces/Report';
import {CONFIG} from '@/config';
import {ServiceHelper} from '@/utils/service.helper';

export class ReportsService {
  public static ListAllReports = (): Promise<Report[]> =>
      ServiceHelper.mapToPromise<Report[]>(`${CONFIG.URL.NEODASH_API}/api/neodash/getReports`);
}
